/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`

export default class MatchRecordIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" css={Color}>
        <g id="record" transform="translate(-44 -63)">
          <rect id="사각형_11053" data-name="사각형 11053" width="27" height="27" transform="translate(44 63)" fill="#fff"
                opacity="0"/>
          <path id="합치기_615" className="fill" data-name="합치기 615"
                d="M4715,5096.085a2,2,0,0,1-2-2v-8.409a2,2,0,0,1,2-2h1.768V5082.5a.5.5,0,0,1,1,0v1.175h5.7V5082.5a.5.5,0,0,1,1,0v1.175H4726a2,2,0,0,1,2,2v8.409a2,2,0,0,1-2,2Zm-1-2a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1v-8.033h-13Zm8.6-2.678v-1.8a1.6,1.6,0,0,1,3.2,0v1.8a1.6,1.6,0,0,1-3.2,0Zm1-1.8v1.8a.6.6,0,0,0,1.2,0v-1.8a.6.6,0,1,0-1.2,0Zm-8,1.8v-1.8a1.6,1.6,0,1,1,3.2,0v1.8a1.6,1.6,0,1,1-3.2,0Zm1-1.8v1.8a.6.6,0,0,0,1.2,0v-1.8a.6.6,0,1,0-1.2,0Zm3.6,1.884a.5.5,0,1,1,.5.5A.5.5,0,0,1,4720.2,5091.491Zm0-2a.5.5,0,1,1,.5.5A.5.5,0,0,1,4720.2,5089.491Z"
                transform="translate(-4662.969 -5013.3)" fill="#eee"/>
        </g>
      </svg>
    )
  }
}
